
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState, useEffect } from "react";

export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className="bg-white shadow sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between p-4">
        <Link to="/" className="text-xl font-cinzel font-bold text-manuscript-primary">UnitCodex</Link>
        
        <ul className="hidden md:flex space-x-6 text-manuscript-primary">
          <li><Link to="/" className="hover:text-manuscript-primary/70 transition-colors">Home</Link></li>
          <li><Link to="/history" className="hover:text-manuscript-primary/70 transition-colors">History</Link></li>
          <li><Link to="/blog" className="hover:text-manuscript-primary/70 transition-colors">Blog</Link></li>
          <li><Link to="/faqs" className="hover:text-manuscript-primary/70 transition-colors">FAQs</Link></li>
          <li><Link to="/resources" className="hover:text-manuscript-primary/70 transition-colors">Resources</Link></li>
          <li><Link to="/about" className="hover:text-manuscript-primary/70 transition-colors">About</Link></li>
        </ul>

        <button 
          className="block md:hidden text-manuscript-primary"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <Menu className="h-8 w-8" />
        </button>
      </div>
      
      {isMenuOpen && (
        <div className="md:hidden border-t border-manuscript-secondary bg-white/95 backdrop-blur-sm fixed w-full">
          <div className="container mx-auto py-6 space-y-6">
            <Link to="/" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">Home</Link>
            <Link to="/history" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">History</Link>
            <Link to="/blog" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">Blog</Link>
            <Link to="/faqs" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">FAQs</Link>
            <Link to="/resources" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">Resources</Link>
            <Link to="/about" className="block text-manuscript-primary text-lg py-2 hover:text-manuscript-primary/70 transition-colors">About</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
